<template>
    <form-row title="Interest Rate">
        <input-percent
            class="w-32"
            :value="mortgage.interest_rate"
            name="interest_rate"
            :read_only="read_only"
        />

        <div class="mt-4 sm:mt-0 flex flex-1 items-center text-sm text-gray-warm-800 sm:pl-10">
            {{ $t('Altering your interest rate may cause a delay of your closing.') }}
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        mortgage: {},
        read_only: { default: false },
    },
}
</script>
